import { callApiToServer } from '../../callApi';

export async function editCoin(
  authtoken,
  coinObject,
  coinId,
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
      
    let body = JSON.stringify({
        coinId: coinId,
        name: coinObject.name,
        price: coinObject.price
    });
  
    let endUrl = "v1/auth/edit-coin";
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
      
  }catch(err) {
    throw err;
  }
}
